import CallingExtensions from './CallingExtensions';
import pubsub from 'sweet-pubsub';
import { AmplitudeLogger, EVENTS } from "../../utils";
import sessionStore from '../../../store/session';
import callStore from '../../../store/call';
import { get } from 'svelte/store';
export const useCti = () => {
    const defaultSize = { width: 320, height: 460 };
    let engagementId = null;
    let phoneNumber = null;
    let callStartTime = null;
    const cti = new CallingExtensions({
        debugMode: true,
        eventHandlers: {
            onReady: () => {
                cti.initialized({ isLoggedIn: true, sizeInfo: defaultSize });
            },
            onDialNumber: (data, _rawEvent) => {
                phoneNumber = data.phoneNumber;
                pubsub.emit('initiate_call', phoneNumber);
            },
            onEngagementCreated: (data, _rawEvent) => {
                engagementId = data.engagementId;
            },
            onCreateEngagementSucceeded: (event) => {
                /* HubSpot has created an engagement for this call. */
                console.log('HUBSPOT');
                console.log(event);
            },
            onEngagementCreatedFailed: (event) => {
                /* HubSpot has failed to create an engagement for this call. */
                console.log('HUBSPOT');
                console.log(event);
            },
            onUpdateEngagementSucceeded: (event) => {
                /* HubSpot has updated an engagement for this call. */
                console.log('HUBSPOT');
                console.log(event);
            },
            onUpdateEngagementFailed: (event) => {
                /* HubSpot has failed to update an engagement for this call. */
                console.log('HUBSPOT');
                console.log(event);
            },
            onVisibilityChanged: (data, _rawEvent) => {
                // nothing to do here
                console.log('HUBSPOT');
                console.log(data, _rawEvent);
            },
            defaultEventHandler(event) {
                console.info('Event received. Do you need to handle it?', event);
            },
            onCallerIdMatchSucceeded: (data) => {
                /* HubSpot has fetched caller id matches for this call. */
                console.log(">>>>>>>>>>> hubspot contact found >>>>>>>>>>>>");
                console.log(data);
                const { callerIdMatches } = data;
                if (callerIdMatches && callerIdMatches.length > 0) {
                    const callerIdMatch = callerIdMatches[0];
                    const { firstName, lastName, name, objectCoordinates, } = callerIdMatch;
                    const __name__ = name || `${firstName} ${lastName}`;
                    const initials = `${firstName ? firstName.charAt(0) : ''} ${lastName ? lastName.charAt(0) : ''}`;
                    if (objectCoordinates) {
                        const payload = {
                            objectCoordinates,
                        };
                        cti.navigateToRecord(payload);
                    }
                    callStore.update({
                        peerName: __name__,
                        peerInitials: initials
                    });
                }
            },
            onCallerIdMatchFailed(event) {
                /* HubSpot has failed to fetch caller id matches for this call. */
                const { error: { message }, } = event;
                console.log('HUBSPOT');
                console.log(event, message);
            }
        },
    });
    pubsub.on('login', ({ mobile, email, first_name, last_name }) => {
        AmplitudeLogger.log(EVENTS.LOGIN, { mobile, email, first_name, last_name });
        cti.userLoggedIn();
        if (phoneNumber) {
            pubsub.emit('initiate_call', phoneNumber);
        }
    });
    pubsub.on('number_selected', ({}) => {
        AmplitudeLogger.log(EVENTS.NUMBER_SELECTED, { number: phoneNumber });
        console.log('NUMBER_SELECTED');
        callStartTime = null;
        // if ( phoneNumber ) {
        //     pubsub.emit('initiate_call', phoneNumber);
        // }
    });
    pubsub.on('call_started', ({ direction, peer }) => {
        console.log('CALL_PICKED');
        console.log(peer);
        callStartTime = Date.now();
        const { receiver } = get(sessionStore);
        const payload = {
            createEngagement: true,
            callStartTime,
            toNumber: peer,
            fromNumber: receiver.business_number.phone_number,
            phoneNumber
        };
        AmplitudeLogger.log(EVENTS.CALL_STARTED, payload);
        cti.callAnswered(payload);
        cti.outgoingCall(payload);
    });
    pubsub.on('call_missed', ({ peer: phoneNumber }) => {
        console.log('CALL_MISSED');
        console.log(phoneNumber);
        callStartTime = Date.now();
        const payload = {
            createEngagement: true,
            callStartTime,
            phoneNumber
        };
        cti.callAnswered(payload);
        cti.outgoingCall(payload);
        const { notes } = get(callStore);
        setTimeout(() => {
            if (engagementId) {
                cti.callCompleted({
                    engagementId,
                    hideWidget: false,
                    engagementProperties: {
                        hs_call_body: notes || "missed call",
                        hs_call_duration: "0",
                        hs_call_to_number: phoneNumber || '',
                        hs_call_title: `Missed call [${phoneNumber}]`
                    },
                });
                cti.callEnded({
                    callEndStatus: "COMPLETED",
                });
                engagementId = null;
            }
        }, 1000);
        callStartTime = null;
    });
    pubsub.on('call_ended', ({ direction, peer, duration, notes }) => {
        console.log('CALL_ENDED');
        console.log(peer);
        const __duration = (duration && duration > 0) ? duration : callStartTime ? ((new Date).getTime() - callStartTime.getTime()) / 1000 : 0;
        AmplitudeLogger.log(EVENTS.CALL_ENDED, { direction, peer, duration, notes });
        if (engagementId) {
            cti.callCompleted({
                engagementId,
                hideWidget: false,
                engagementProperties: {
                    hs_call_body: notes,
                    hs_call_duration: __duration.toString(),
                    hs_call_to_number: peer,
                    hs_call_title: `Call with ${peer}`
                },
            });
            cti.callEnded({
                callEndStatus: "COMPLETED",
            });
            engagementId = null;
        }
        callStartTime = null;
    });
    pubsub.on('call_ringing', ({ peer: fromNumber }) => {
        console.log('INCOMING_CALL');
        console.log(fromNumber);
        const { receiver } = get(sessionStore);
        // callStartTime = null
        const callInfo = {
            fromNumber,
            toNumber: receiver.business_number.phone_number,
            createEngagement: true,
        };
        cti.incomingCall(callInfo);
        AmplitudeLogger.log(EVENTS.RINGING, { fromNumber });
    });
    pubsub.on('logout', () => {
        cti.userLoggedOut();
    });
    return cti;
};
